module.exports = __webpack_public_path__ + "static/media/3-食物查询.5dc9ca1a.png";